<template>
  <div class="filter-view">
    <div class="flex-row">
      <h3 class="table-title">{{$t('leaderboard_list')}}</h3>
    </div>
    <div class="justify-end-div" v-if="rightAction">
      <div class="justify-end-search" style="padding-right: 30px; gap: 10px">
        <button class="dark-button-outline" @click="resetLeaderboard">{{$t('reset_the_leaderboard')}}</button>

        <TableDownload
            :data="users"
            :fields="['gamificationInfo.leaderboardRank', 'name', 'surname', 'gamificationInfo.leaderboardScore', 'status', 'createdAt', 'email', 'phone']"
            :headers="{
        'gamificationInfo.leaderboardRank': $t('rank'),
        name: $t('name_payment'),
        surname: $t('surname_person'),
        'gamificationInfo.leaderboardScore': 'Point',
        status: $t('status_payment_title'),
        createdAt: $t('added_date'),
        email: $t('email_address'),
        phone: $t('phone_number_person')
    }"
            :filename="$t('gamification_report')"
        />
        <ExpandableSearch :searchText="searchText" :on-change="handleSearch" />
      </div>
    </div>
  </div>

  <div class="table-container">
    <table class="content-table">
      <thead class="header-table">
      <tr class="trhead">
        <th>#</th>
        <th @click="handleSort('name')" class="sortable-header">
          {{ $t('name_payment') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('name')"
          >
        </th>
        <th @click="handleSort('leaderboardScore')" class="sortable-header" style="text-align: start">
          Point
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('leaderboardScore')"
          >
        </th>

        <th @click="handleSort('status')" class="sortable-header">
          {{ $t('status_payment_title') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('status')"
          >
        </th>
        <th @click="handleSort('createdAt')" class="sortable-header" style="text-align: start">
          {{ $t('added_date') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('createdAt')"
          >
        </th>

        <th @click="handleSort('email')" class="sortable-header">
          {{ $t('email_address') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('email')"
          >
        </th>
        <th @click="handleSort('phone')" class="sortable-header">
          {{$t('phone_number_person') }}
          <img
              src="../../../assets/images/status.svg"
              class="sort-icon"
              :class="getSortClass('phone')"
          >
        </th>
      </tr>
      </thead>
      <tbody class="tbody-container">
      <tr class="tr-class" v-if="!loading" v-for="user in users" :key="user.userId">
        <td class="td-style"><div class="rank-div"> <span class="rank-text">{{user.gamificationInfo.leaderboardRank}}</span> </div></td>

        <td class="td-style">
          <router-link :to="'/users/detail/' + user.userId" class="name-row">
            <template v-if="user.avatarUrl">
              <div class="user-avatar-container">
                <img class="company-icon" :src="user.avatarUrl" />
                <img v-if="user.gamificationInfo?.badge?.badgeUrl" class="badge-styling" :src="user.gamificationInfo.badge.badgeUrl" />
              </div>
            </template>
            <template v-else>
              <em class="no-data-text">{{$t('no_data')}}</em>
            </template>
            <template v-if="user.name || user.surname">
              <span class="test-class">{{ truncateText(user.name + ' ' + user.surname, 15) }}</span>

            </template>
            <template v-else>
              <em class="no-data-text">N/A</em>
            </template>
          </router-link>
        </td>
        <td class="td-style">
          <div class="point-div">
            <span class="point-styling">{{user.gamificationInfo.leaderboardScore}} pt</span>
          </div>
        </td>

        <td class="td-style">
            <span class="test-class-status">
              <img v-if="user.status=== true" src="../../../assets/images/active.svg">
              <img v-else src="../../../assets/images/failed.svg">
              <span v-if="user.status">
                {{ $t('active') }}
              </span>
              <span v-else>
                {{ $t('inactive') }}
              </span>
            </span>
        </td>
        <td class="td-style">
            <span class="test-class">
              <img src="../../../assets/images/datepicker.svg">
              {{ truncateText(user.createdAt, 30) }}
            </span>
        </td>

        <td class="td-style">
          <span class="test-class">{{ truncateText(user.email, 20) }}</span>
        </td>

        <td class="td-style">
          <template v-if="user.phone">
            <span class="test-class">{{ truncateText(user.phone, 15) }}</span>
          </template>
          <template v-else>
            <em class="no-data-text">N/A</em>
          </template>
        </td>

      </tr>

      <tr v-else>
        <td colspan="7" class="table-loading">
          <VueSpinner size="16" height="100%" color="#8c8c8c" />
          <span class="text">{{$t('loading')}}</span>
        </td>
      </tr>

      <tr v-if="!loading && users.length === 0 ">
        <td colspan="7" class="table-loading">
          <span class="no-data-found">{{$t('no_data_found')}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="bottom-user-actions" v-if="selectedUserIds.length > 0">
    <span class="selected-label">{{$t('selected')}} {{selectedUserIds.length}} {{$t('user')}}</span>
    <ActionDropdown :actions="departmentActions" :on-action="handleDepartmentAction" :placeholder="$t('departments')" />
  </div>
</template>

<script>
import AddUserModal from '@/components/modals/InviteUserModal.vue';
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import {VueSpinner} from "vue3-spinners";
import GamificationFilters from "@/components/tables/Gamification/GamificationFilters.vue";
import companyService from "@/service/companyService";
import commonService from "@/service/commonService";
import userService from "@/service/userService";
import {handleErrorResponse} from "@/utils/utils";
import ActionDropdown from "@/components/ActionDropdown.vue";
import TableDownload from "@/components/TableDownload.vue";
import gamificationService from "../../../service/gamificationService";

export default {
  components: {
    TableDownload,
    GamificationFilters,
    AddUserModal,
    ExpandableSearch,
    VueSpinner,
    ActionDropdown
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    users: {
      type: Array,
      required: true
    },
    rightAction: {
      type: Boolean,
      default: true
    },
    companyId:{
      type:Number,
      default:null
    },
    code: {
      type:Number,
      default:null
    },
    refreshData: {
      type: Function,
      default: () => {}
    },
    currentSort: {
      type: Object,
      default: () => ({ column: null, direction: null })
    },
    onSort: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      inviteCode: null,
      showModal: false,
      selectAll: false,
      showFilter: false,
      searchText: '',
      selectedUserIds: [],
      departmentList: [],
      departmentActions: [],
      isProcessing: false
    }
  },
  created() {
    this.inviteCode = this.code;
    this.loadDepartments();
  },
  methods: {
    handleSort(column) {
      let newDirection = 'asc';

      if (this.currentSort.column === column) {
        if (this.currentSort.direction === 'asc') {
          newDirection = 'desc';
        } else if (this.currentSort.direction === 'desc') {
          this.onSort(null, null);
          return;
        }
      }

      this.onSort(column, newDirection);
    },

    getSortClass(column) {
      if (this.currentSort.column !== column) {
        return 'sort-default';
      }

      if (this.currentSort.direction === 'asc') {
        return 'sort-asc';
      } else if (this.currentSort.direction === 'desc') {
        return 'sort-desc';
      }

      return 'sort-default';
    },

    loadDepartments() {
      commonService.getDepartments().then(response => {
        this.departmentList = response.data.data.departments.filter(department =>
            department.name && department.name.trim() !== ''
        );

        this.departmentActions = this.departmentList.map(dept => ({
          name: dept.name,
          action: dept.id.toString()
        }));

      }).catch(err => {
        handleErrorResponse(err, this.$snackbar);
      });
    },
    copyCode() {
      if(this.inviteCode) {
        navigator.clipboard
            .writeText(this.inviteCode)
            .then(() => {
              this.$snackbar.add({
                text: this.$t("create_invite_code_success"),
                type: "success"
              });
            })
      }
      if(this.inviteCode === null){
        this.$snackbar.add({
          text: this.$t("create_invite_code_error"),
          type:"error"
        });
      }
    },
    resetLeaderboard(){
      gamificationService.resetLeaderboard().then(response => {
        this.$snackbar.add({
          text: 'Liderlik tablosu başarıyla sıfırlandı',
          type: "success"
        });
        this.refreshData();
      }).catch(err => {
        handleErrorResponse(err, this.$snackbar);
      });
    },
    toggleAll() {
      this.selectAll = !this.selectAll;
      if (this.selectAll) {
        this.selectedUserIds = this.users.map(user => user.userId);
      } else {
        this.selectedUserIds = [];
      }
    },
    toggleUser(e, userId) {
      if (e.target.checked) {
        this.selectedUserIds.push(userId);
      } else {
        this.selectedUserIds = this.selectedUserIds.filter(id => id !== userId);
      }
    },
    handleSearch(event) {
      this.searchText = event.target.value;
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    handleDepartmentAction(action) {
      if (!action || !this.selectedUserIds.length || this.isProcessing) {
        return;
      }

      this.isProcessing = true;

      const departmentId = action;

      this.assignDepartmentToUsers(departmentId);
    },
    assignDepartmentToUsers(departmentId) {
      const department = this.departmentList.find(dept => dept.id.toString() === departmentId);

      userService.assignDepartmentToUsers(this.selectedUserIds, departmentId)
          .then((response) => {
            this.$snackbar.add({
              text: `${this.selectedUserIds.length} kullanıcı ${department ? department.name : ''} kullanıcı grubuna atandı`,
              type: 'success'
            });

            this.selectedUserIds = [];
            this.selectAll = false;
            this.refreshData();
          })
          .catch(err => {
            handleErrorResponse(err, this.$snackbar);
          })
          .finally(() => {
            this.isProcessing = false;
          });
    }
  }
}
</script>

<style>
.sortable-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #f5f5f5;
}

.sort-icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
  vertical-align: middle;
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: inline-block;
  opacity: 0.4;
}

.sortable-header:hover .sort-icon {
  opacity: 0.6;
}

.sort-icon.sort-asc,
.sort-icon.sort-desc {
  opacity: 1;
}

.sort-icon.sort-asc {
  transform: rotate(0deg);
}

.sort-icon.sort-desc {
  transform: rotate(180deg);
}

.sort-icon.sort-default {
  transform: rotate(0deg);
  opacity: 0.4;
}

.bottom-user-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  margin-top: 8px;
}

.selected-label {
  margin-right: 16px;
  font-size: 14px;
  color: #6b7280;
}
.point-div{
  padding: 4px 8px;
  background-color: #EBEDFB;
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.point-styling{
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: #0E121B;
}

.flex-row{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
}

.filter-view{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  min-height: 52px;
}
.justify-end-div{
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: center;
}
.justify-end-search{
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  font-size: 12px;
  color: #344054;
  font-feature-settings: 'clig' off, 'liga' off;
  border-radius: 8px;
  padding: 8px;
}

.company-icon {
  height: 32px;
  width: 32px;
  border-radius: 50%;
}

.show-filters{
  font-family: euclid_medium, sans-serif;
  color: #4A68F8;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;
}

.row-item-icon {
  height: 16px;
  width: 16px;
}

.name-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.name-row span {
  font-family: euclid_medium, sans-serif;
  color: #000;
}

.name-row:hover.name-row span{
  color: #4A68F8;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.company-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ddd;
}

.no-data-text {
  font-style: italic;
  color: #B6C1DB;
  font-size: 12px;
  font-weight: bold;
}
.rank-div{
  padding: 8px;
  background-color: #EAECF0;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}
.rank-text{
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
}
.user-avatar-container{
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;
}
.badge-styling{
  position: absolute;
  bottom: -10px;
  right: -10px;
  width: 22px;
  height: 22px;
}
.table-title {
  font-size: 20px;
  color: #040C2D;
}

.test-class-status{
  display: flex;
  align-items: center;
  gap: 5px;
  flex-direction: row;
}
</style>
